export default "__VITE_ASSET__D9gfIY6L__"